export default {
  userTargets: [],
  userTarget: undefined,
};
